<template>
    <div v-if="archives.length"
        class="session-archives">
        <VideoArchiveLink v-for="archive in archives"
            :key="archive.id"
            :archive="archive"
            @reload="reloadArchives"
        />
    </div>
</template>

<script>
    import VideoArchiveLink from "./VideoArchiveLink";

    export default {
        name: "SessionArchives",
        props: {
            id: { type: Number },  //appointmentId
        },
        data: function () {
            return {
                refreshInterval: null,
            }
        },
        computed: {
            archives() {
                return this.$store.getters['videoarchives/byAppointmentId'](this.id);
            },
        },
        mounted: function () {
            this.reloadArchives();
        },
        components: {
            VideoArchiveLink,
        },
        methods: {
            reloadArchives() {
                this.$store.dispatch('videoarchives/fetchArchives', this.id);
            },
            hasPending() {
                // Return true if any of the archives have not been archived yet
                for (let i=0; i< this.archives.length; i++) {
                    if (!this.archives[i].archived_at) { return true; }
                }
                return false;
            },
        },
        created() {
            this.refreshInterval = setInterval(() => {
                if (this.hasPending()) {
                    console.log("Refreshing archives");
                    this.reloadArchives();
                }
            }, 60000); // Check every 60 seconds for updates

            this.isLoading = false;
        },
        beforeDestroy() {
            clearInterval(this.refreshInterval);
        },

    }
</script>

<style>
.session-archives {
    margin: 10px 0;
    padding: 10px;
    border: 1px solid #eee;
    border-radius: 5px;
    background-color: #f6f6f6;
}
</style>